export default __webpack_public_path__ + "static/media/Lluvia_ligera.55a6444c.svg";